import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text as ChakraText,
} from '@chakra-ui/react'
import React, { useState } from 'react'

interface Props {
  isOpen: boolean
  urlEndpointName: string
  onClose(): void
  onSubmit(): Promise<boolean | undefined>
}

export const DeleteModal = ({
  isOpen,
  onClose,
  onSubmit,
  urlEndpointName,
}: Props): React.ReactElement => {
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false)

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Origin</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ChakraText fontSize="1em">
            URL Endpoint {urlEndpointName} will be permanently deleted. Click on
            Submit to proceed with the operation.
          </ChakraText>
        </ModalBody>
        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button
            onClick={onClose}
            variant="outline"
            isDisabled={isDeleteDisabled}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="deleteCTA"
            isDisabled={isDeleteDisabled}
            onClick={async () => {
              setIsDeleteDisabled(true)
              const isDeleteSuccessful = await onSubmit()
              setIsDeleteDisabled(false)

              if (isDeleteSuccessful) {
                onClose()
              }
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
